import axios from "axios";

class Api {
  constructor() {
    this.api = axios.create({
      // baseURL: "http://localhost:9000/",

      baseURL: "https://apidenuncia.1rigo.com/",
    });
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers = {
            Authorization: `Bearer ${token}`,
          };
        }
        return config;
      },
      (error) => {
        console.log(error);
      }
    );
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("userId");
          window.location = "/admin/login";
        }
        throw error;
      }
    );
  }
  login = async (loginInfo) => {
    console.log(loginInfo);
    try {
      const { data } = await this.api.post("/user/auth/login", loginInfo);
      console.log(data);
      localStorage.setItem("token", data.token);
      localStorage.setItem("userId", data.userId);
      localStorage.setItem("entidade", data.entidade);
      localStorage.setItem(
        "tokenExpirationTimestamp",
        data.expirationTimestamp
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  signup = async (signupInfo) => {
    try {
      const { data } = await this.api.post("/user/auth/signup", signupInfo);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getUsers = async (entidade) => {
    try {
      const { data } = await this.api.get("/users", entidade);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getUsersAdmin = async (userId) => {
    try {
      const { data } = await this.api.get("/admin/user", userId);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getUsersDenuncia = async () => {
    try {
      const { data } = await this.api.get("/admin/denuncias/users");
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getUserLogged = async (userId) => {
    try {
      const { data } = await this.api.get(
        `/admin/denuncia/user/logged/${userId}`
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  addComplaint = async (complaintData, category) => {
    try {
      const { data } = await this.api.post(
        `/add-complaint/${category}`,
        complaintData
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  checkPassword = async (protocolo_id, senha) => {
    try {
      const { data } = await this.api.post(
        `/track-complaint/${protocolo_id}/${senha}/`
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };

  trackComplaint = async (protocolo_id, pass_protocolo) => {
    try {
      const { data } = await this.api.get(
        `/track-complaint/${protocolo_id}/${pass_protocolo}`
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  sendMessageUser = async (protocolo_id, pass_protocolo, messageUser, user) => {
    try {
      const { data } = await this.api.patch(
        `/track-complaint/${protocolo_id}/${pass_protocolo}`,
        messageUser,
        user
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };

  /*ADMIN FUNCTIONS*/
  getAuditById = async (complaintId) => {
    try {
      const { data } = await this.api.get(
        `/admin/audit/denuncia/${complaintId}`
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  addAudit = async (id, userId) => {
    try {
      const { data } = await this.api.patch(
        `/admin/denuncia/assumir/${id}`,
        userId
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  endAudit = async (denunciaId, userId, tipo) => {
    try {
      const { data } = await this.api.post(
        `/admin/denuncia/${denunciaId}/${userId}`,
        tipo
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  sendMessage = async (id, messageUser, userId, userName, changeEtapa) => {
    try {
      const { data } = await this.api.patch(
        `/admin/denuncia/message/${id}`,
        messageUser,
        userId,
        userName,
        changeEtapa
      );
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getDenuncias = async () => {
    try {
      const { data } = await this.api.get(`/admin/home`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getDenuncia = async (id) => {
    try {
      const { data } = await this.api.get(`/admin/denuncia/${id}`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getAllDenuncias = async () => {
    try {
      const { data } = await this.api.get(`/admin/denuncias/`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };

  getDenunciasTodas = async () => {
    try {
      const { data } = await this.api.get(`/admin/denuncias/mailbox/todas/`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getDenunciasUser = async (userId) => {
    try {
      const { data } = await this.api.get("/admin/denuncias/mailbox/", userId);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getDenunciasByStatus = async (status) => {
    try {
      const { data } = await this.api.get(`/admin/denuncias/status/${status}`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getDenunciasByEtapa = async (etapa) => {
    try {
      const { data } = await this.api.get(`/admin/denuncias/etapa/${etapa}`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getDenunciasByType = async (type) => {
    try {
      const { data } = await this.api.get(`/admin/tipo/${type}`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
  getDenunciasAbertas = async () => {
    try {
      const { data } = await this.api.get(`/admin/denuncias/abertas`);
      return data;
    } catch (error) {
      throw error.response.data.msg;
    }
  };
}

/* eslint-disable-next-line*/
export default new Api();
